import type { UndecoratedUser } from '@witmetrics/utils';
import { useDateFormatPreference } from '@witmetrics/data-store';
import { formatUserName } from '@witmetrics/utils/strings';
import { formatDateWithTime } from '@witmetrics/utils/time';
import OptionsMenu from './OptionsMenu';
import { classes } from './utils';

export type BlockHeaderProps = {
  editable?: boolean;
  createdBy?: UndecoratedUser;
  createdAt: string;
  onEdit: () => void;
  onDelete: () => void;
};

export default function BlockHeader({
  editable,
  createdBy,
  createdAt,
  onEdit,
  onDelete,
}: BlockHeaderProps) {
  const dateFormat = useDateFormatPreference();
  return (
    <div className={classes.wrapper}>
      <div className={classes.authorWrapper}>
        {/*{renderIcon()}*/}
        {createdBy && (
          <span className={classes.createdBy}>{formatUserName(createdBy)}</span>
        )}
        <span className={classes.createdAt}>
          {formatDateWithTime(createdAt, dateFormat)}
        </span>
      </div>
      <div>
        {editable && <OptionsMenu onEdit={onEdit} onDelete={onDelete} />}
      </div>
    </div>
  );
}
